import {
    WITHDRAWAPPROVEREJECT_SUCCESS,
    WITHDRAWAPPROVEREJECT_FAILED,
    RESET_WITHDRAWAPPROVEREJECT,
    LOADING_WITHDRAWAPPROVEREJECT,
    NETWORK_ERROR_WITHDRAWAPPROVEREJECT
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetWithdrawApproveRejectList = () => {
    return { type: RESET_WITHDRAWAPPROVEREJECT };
};

const partnerWithdrawApproveRejectList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_WITHDRAWAPPROVEREJECT });
    await partnerServices
        .post("withdrawapprovereject", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerWithdrawApprovesuccess(res.data));
                    break;
                default:
                    dispatch(partnerWithdrawApproveFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_WITHDRAWAPPROVEREJECT,
                payload: err
            });
        });
};

function partnerWithdrawApprovesuccess(data) {
    return {
        type: WITHDRAWAPPROVEREJECT_SUCCESS,
        payload: data,
    };
}

function partnerWithdrawApproveFailed(data) {
    return {
        type: WITHDRAWAPPROVEREJECT_FAILED,
        payload: data,
    };
}

export { resetWithdrawApproveRejectList, partnerWithdrawApproveRejectList }